import { categories } from "@/mocks/suye";
import SectionHeading from "./SectionHeading";

const tones = [
  { iconBg: "bg-primary-500", bubble: "bg-primary-100", text: "text-primary-700" },
  { iconBg: "bg-accent-600", bubble: "bg-accent-100", text: "text-accent-800" },
  { iconBg: "bg-secondary-600", bubble: "bg-secondary-100", text: "text-secondary-800" },
  { iconBg: "bg-primary-400", bubble: "bg-primary-100", text: "text-primary-700" },
  { iconBg: "bg-accent-500", bubble: "bg-accent-100", text: "text-accent-800" },
  { iconBg: "bg-foreground-800", bubble: "bg-background-200", text: "text-foreground-700" },
];

export default function CategoryGrid() {
  return (
    <section id="cats" className="border-b border-background-200 bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          kicker="话题分类"
          title={
            <>
              你想吃的瓜，<span className="text-primary-600">都在这六个场子</span>
            </>
          }
          desc="选择你感兴趣的领域，进去就能看到围绕它正在发酵的热议与讨论。"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {categories.map((c, idx) => {
            const t = tones[idx % tones.length];
            return (
              <a
                key={c.id}
                href="#live"
                className="group relative overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200"
              >
                <div className="flex items-start justify-between">
                  <span className={"flex h-12 w-12 items-center justify-center rounded-xl text-background-50 " + t.iconBg}>
                    <i className={c.icon + " text-xl"} />
                  </span>
                  <span className="rounded-full bg-background-100 px-2.5 py-1 text-xs text-foreground-500">
                    {c.count} 在线
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{c.name}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
                <span className={"mt-4 inline-flex items-center gap-1.5 text-sm font-medium " + t.text}>
                  进入围观
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}